import { connect } from 'react-redux';
import { TermAndConditions } from '../../components';

export default connect(null)(TermAndConditions);